// Theme loaders – load jQuery and Swiper on demand (no global load).
// Must be included in <head> without defer so sections can call these before body finishes parsing.
//
// Updated 2026-08-20:
// - Libraries are self-hosted in theme assets (Shopify CDN) instead of third-party CDNs.
//   URLs are injected as globals (SWIPER_JS_URL, SWIPER_CSS_URL, JQUERY_URL) from theme.liquid,
//   with the old third-party CDN URLs kept as fallbacks.
// - Failed loads retry twice (1.5s apart) with a cache-busting query param.
// - A failed load no longer poisons the cached promise: the cache is cleared on final
//   failure so a later call (e.g. after connectivity returns) can try again.
// - Fixed a race in the jQuery loader where concurrent calls during an in-flight load
//   received undefined instead of the pending promise.

(function () {
  "use strict";

  // Generic script loader with retry. Resolves with getGlobal() on success, null on final failure.
  function loadScriptWithRetry(url, getGlobal, maxAttempts) {
    return new Promise(function (resolve) {
      var tryLoad = function (attempt) {
        var script = document.createElement("script");
        script.src = url + (attempt > 1 ? (url.indexOf("?") === -1 ? "?" : "&") + "retry=" + attempt : "");
        script.onload = function () {
          resolve(getGlobal());
        };
        script.onerror = function () {
          script.remove();
          if (attempt < maxAttempts) {
            setTimeout(function () {
              tryLoad(attempt + 1);
            }, 1500);
          } else {
            console.error("Failed to load " + url + " after " + maxAttempts + " attempts");
            resolve(null);
          }
        };
        document.head.appendChild(script);
      };
      tryLoad(1);
    });
  }

  // ---------------------------------------------------------------------------
  // jQuery
  // ---------------------------------------------------------------------------
  window.jqueryCheckAndLoad = function () {
    // Return the in-flight or completed promise if one exists (fixes concurrency race).
    if (window._jqueryLoadPromise) return window._jqueryLoadPromise;

    if (typeof window.jQuery !== "undefined") {
      window._jqueryLoadPromise = Promise.resolve(window.jQuery);
      return window._jqueryLoadPromise;
    }

    var jsUrl = window.JQUERY_URL || "https://code.jquery.com/jquery-3.7.1.min.js";

    window._jqueryLoadPromise = loadScriptWithRetry(
      jsUrl,
      function () { return window.jQuery; },
      3
    ).then(function (jq) {
      if (!jq) {
        // Clear the cache so a later call can retry from scratch.
        window._jqueryLoadPromise = null;
      }
      return jq;
    });

    return window._jqueryLoadPromise;
  };

  // ---------------------------------------------------------------------------
  // Swiper
  // ---------------------------------------------------------------------------
  window.swiperCheckAndLoad = function () {
    if (window._swiperLoadPromise) return window._swiperLoadPromise;

    if (typeof window.Swiper !== "undefined") {
      window._swiperLoadPromise = Promise.resolve(window.Swiper);
      return window._swiperLoadPromise;
    }

    var jsUrl = window.SWIPER_JS_URL || "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js";
    var cssUrl = window.SWIPER_CSS_URL || "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css";

    // CSS: fire and forget. A missing stylesheet degrades visuals but should not block JS init.
    if (!window._swiperCssRequested) {
      window._swiperCssRequested = true;
      var link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = cssUrl;
      document.head.appendChild(link);
    }

    window._swiperLoadPromise = loadScriptWithRetry(
      jsUrl,
      function () { return window.Swiper; },
      3
    ).then(function (sw) {
      if (!sw) {
        // Clear the cache so a later call can retry from scratch.
        window._swiperLoadPromise = null;
      }
      return sw;
    });

    return window._swiperLoadPromise;
  };
})();